import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "normalizeMediumDiv" ]

  connect() {
  }

  permissionSelected(event) {
    if ($(event.target).val() == "publisher") {
      $(this.normalizeMediumDivTarget).removeClass("d-none")
    } else {
      $(this.normalizeMediumDivTarget).addClass("d-none")
    }
  }
}
